import {TABOO_INSTANCE_FILTER_CATEGORY_SELECTED} from "app/games/taboo/reducers/currentUserFilterPerInstance";

export default function categorySelected(instanceId, categoryId) {
  return {
    type: TABOO_INSTANCE_FILTER_CATEGORY_SELECTED,
    payload: { instanceId, categoryId },
  }
}
